import { createAuthClient, createGraphQLRefreshTokensFn } from "@axio/auth";
import { createRNTokenStore } from "./tokenStore";

const GRAPHQL_ENDPOINT = typeof window === "undefined" ? "/api/graphql" : `${window.location.origin}/api/graphql`;

const refreshTokens = createGraphQLRefreshTokensFn({ endpoint: GRAPHQL_ENDPOINT });

export const authClient = createAuthClient({
  tokenStore: createRNTokenStore(),
  refreshTokens,
});
